<div class="sidebar-header">{{ headerContent }}</div>
<form class="standard-form" (ngSubmit)="onSubmit()" [formGroup]="outcomeForm">
  <div class="sans-margin">
    <p>{{initiativeDescription}}</p>
  </div>
  <label class="standard-label" for="outcome">Intended Outcome</label>
  <div class="input-error-wrap sans-margin">
      <input auto="outcome-field" class="standard-input block" type="text" id="outcome"
             placeholder="Enter Intended Outcome" name="priority title"
             [formControl]="outcome" [maxLength]="MAX_OUTCOME_LENGTH">
      <div class="remaining-msg">Remaining: {{ outcomeRemainingCharacters }}</div>
    <app-error-msg [control]="outcome" [show]="outcome.invalid && outcome.touched"></app-error-msg>
  </div>
  <div class="secondary-button-row" *ngIf="!isEdit">
      <input auto="add-outcome-modal-btn" class="btn" type="button" [disabled]="isAddDisabled"
             (click)="onAddOutcomeClick()" value="Add"/>
  </div>
  <div class="input-error-wrap sans-margin" *ngIf="!isEdit">
    <p-table auto="outcome-modal-table" [value]="outcomes" styleClass="priorities-table rounded-zebra-table">
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" class="ui-table-empty-message">
            No Intended Outcome(s) Added
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Intended Outcome(s)</th>
          <th class="actions-column"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-outcome>
        <tr>
          <td class="break-text">{{outcome.outcome}}</td>
          <td class="actions-column">
            <div class="fa-icon pointer" (click)="onDeleteOutcomeClick(outcome)">
              <i auto="delete-outcome-modal-btn" class="fa fa-trash"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="button-row">
    <button auto="cancel-outcome-modal-btn" class="btn btn-alt left-btn" type="button"
            (click)="cancel.emit()">Cancel</button>
    <button auto="save-outcome-modal-btn" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
</form>
